export const NEURO_GENERATION_DURATION_MINUTES = 30;

const SECONDS_IN_MINUTE = 60;
const MILLISECONDS_IN_SECOND = 1000;

export const NEURO_GENERATION_POLL_INTERVAL_MS =
  SECONDS_IN_MINUTE * MILLISECONDS_IN_SECOND;
const PERCENT_DISPLAY_MAX = 99;

export const NEURO_GENERATION_DURATION_SECONDS =
  NEURO_GENERATION_DURATION_MINUTES * SECONDS_IN_MINUTE;

export const getNeuroGenerationProgressPercent = (
  dateUpdate: number,
  currentTimestamp = Math.floor(Date.now() / 1000)
) => {
  if (dateUpdate <= 0) {
    return 0;
  }

  const elapsedSeconds = Math.max(0, currentTimestamp - dateUpdate);
  const progress = (elapsedSeconds / NEURO_GENERATION_DURATION_SECONDS) * 100;

  return Math.min(PERCENT_DISPLAY_MAX, Math.floor(progress));
};
